// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.sf-section{margin:var(--section-margin,calc(var(--spacer-lg)*2) 0 var(--spacer-lg) 0)}.sf-section__content{margin:var(--section-content-margin,calc(var(--spacer-lg)*2) 0 0 0)}@media(min-width:1024px){.sf-section{--section-margin:var(--spacer-3xl) 0;--section-content-margin:var(--spacer-2xl) 0 0 0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
